import React from "react";

const blogPosts = [
  {
    title: "Pune to Mahabaleshwar Cab",
    image: "/images/keyword/1.jpg",
    para:
      "Comfortable and reliable cab service from Pune to Mahabaleshwar with Prince Cabs. Enjoy a safe and hassle-free journey.",
    link: "/pune-to-mahabaleshwar-cab",
  },
  {
    title: "Pune to Ashtavinayak Cab",
    image: "/images/keyword/6.jpg",
    para:
      "Enjoy a comfortable and punctual ride from Pune to Ashtavinayak temples with Prince Cabs. Perfect for your spiritual journey.",
    link: "/pune-to-ashtavinayak-cab",
  },
  {
    title: "Pune to Bhimashankar Cab",
    image: "/images/keyword/4.jpg",
    para:
      "Prince Cabs offers convenient Pune to Bhimashankar cab service for a smooth and peaceful journey.",
    link: "/pune-to-bhimashankar-cab",
  },
];

const slugify = (s) =>
  s
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-+|-+$/g, "");

const BlogSection = () => {
  return (
    <section className="pc-blog">
      <div className="container">
        <div className="section-heading text-center">
          <h5 className="pc-dash">FROM OUR BLOG</h5>
          <h2 className="pc-heading">OUR RECENT POSTS</h2>
        </div>

        <div className="row g-4">
          {blogPosts.map((post, index) => {
            const href = post.link || `/${slugify(post.title)}`;
            return (
              <div className="col-md-6 col-lg-4" key={index}>
                <article className="pc-post">
                  <a href={href} className="pc-thumb">
                    <img src={post.image} alt={post.title} loading="lazy" />
                    <span className="pc-rail" aria-hidden />
                    <span className="pc-ribbon" aria-hidden>Prince Cabs</span>
                  </a>

                  <div className="pc-content">
                    <h3 className="pc-title">
                      <a href={href}>{post.title}</a>
                    </h3>
                    <p className="pc-desc">{post.para}</p>

                    <a className="pc-read" href={href}>
                      Read more <span>›</span>
                    </a>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
